import React, { useCallback, useEffect, useState } from 'react';
import IconClose from '@creditflowresearch/uilib/Icon/IconClose';

import styles from './themeToggleOnboarding.module.scss';
import IconButton from '@creditflowresearch/uilib/IconButton';

const STORAGE_KEY = 'cfr-dark-mode-tooltip-dismissed';
const AUTO_DISMISS_DELAY_MS = 8000;

interface IProps {
  onDismiss: () => void,
}

const ThemeToggleOnboarding = ({ onDismiss }: IProps): React.ReactElement | null => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = useCallback((): void => {
    setIsVisible(false);
    localStorage.setItem(STORAGE_KEY, '1');
    onDismiss();
  }, [onDismiss]);

  useEffect(() => {
    if (!isVisible) return undefined;

    const timer = setTimeout(handleDismiss, AUTO_DISMISS_DELAY_MS);
    return () => clearTimeout(timer);
  }, [isVisible, handleDismiss]);

  if (!isVisible) return null;

  return (
    <div className={ styles.container } role="status" aria-live="polite" data-test="themeToggleOnboarding">
      <div className={ styles.arrow } />
      <div className={ styles.content }>
        <IconButton
          icon={ <IconClose className={ styles.closeIcon } /> }
          className={ styles.closeButton }
          onClick={ handleDismiss }
          ariaLabel="Close tooltip"
          dataTest="themeToggleOnboardingClose"
        />
        <h3 className={ styles.title }>Dark mode now available</h3>
        <p className={ styles.body }>
          Customize your CreditFlow experience by switching to Dark Mode.
        </p>
      </div>
    </div>
  );
};

export default ThemeToggleOnboarding;
